import { IntlShape, MessageDescriptor } from 'react-intl';

import { stringFormatter } from '@nhl/formatter-utilities';
import { CoreUtils, ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

export const getSize = (intl: IntlShape, label: MessageDescriptor, size: number): number =>
    intl.locale !== ShortCodeEnums.Language.English
        ? stringFormatter.getLabelSize(CoreUtils.safeFormatMessage(intl, label), size)
        : size;
